import { render, staticRenderFns } from "./TabGeneralView.vue?vue&type=template&id=7831ac80&scoped=true&lang=pug"
import script from "./TabGeneralView.vue?vue&type=script&lang=js"
export * from "./TabGeneralView.vue?vue&type=script&lang=js"
import style0 from "./TabGeneralView.vue?vue&type=style&index=0&id=7831ac80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831ac80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7831ac80')) {
      api.createRecord('7831ac80', component.options)
    } else {
      api.reload('7831ac80', component.options)
    }
    module.hot.accept("./TabGeneralView.vue?vue&type=template&id=7831ac80&scoped=true&lang=pug", function () {
      api.rerender('7831ac80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/workbook/TabGeneralView.vue"
export default component.exports